import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear';
import { Icon, Tooltip } from '@kontentino/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { stopPropagation } from 'utils/mouseEvent';
type Props = {
  onClick: () => void;
  className?: string;
};

const ProfileSelectorOptionEditButton: FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslation();

  return (
    <Tooltip content={t('edit')}>
      <div
        onClick={stopPropagation(onClick)}
        className={className}
        data-cy="profile-option_edit-button"
      >
        <Icon icon={faGear} size={16} className="tw-text-grayscale-70" />
      </div>
    </Tooltip>
  );
};

export default ProfileSelectorOptionEditButton;
